module.exports = __webpack_public_path__ + "fonts/junction-bold.62d02ff2.eot";